<template>
    <div class="information" :style="[backImage ? {backgroundImage: 'url(' + backImage + ')'} : null]">
        <img v-if="!backImage && image" :src="image" alt="description" class="information__image" :style="{ width: imageWidth}">
    </div>
</template>

<script>
export default {
  name: "Information",
  props: {
    image: {
      default: '',
      required: false
    },
    imageWidth: {
      default: '100%',
      required: false
    },
    backImage: {
      default: '',
      required: false
    }
  },
}
</script>

<style scoped>

</style>
